import {useTranslation} from "react-i18next";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {Alert, CircularProgress} from "@mui/material";
import Stack from "@mui/material/Stack";
import DialogActions from "@mui/material/DialogActions";
import MDButton from "../../materialDashboard/components/MDButton";
import React from "react";
import {useExportTaskPollingQuery} from "./query";


const ExportTaskDialogContent = ({exportTaskId, handleClose}) => {
    const {t} = useTranslation(["exportTasks"]);
    const exportTask = useExportTaskPollingQuery({exportTaskId}).data;

    const handleDownloadFile = () => {
        const link = document.createElement("a");
        link.href = exportTask.file.path;
        link.download = exportTask.fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        handleClose();
    }

    return <>
        <DialogTitle>{t('dialog.title')}</DialogTitle>
        <DialogContent>
            {
                (exportTask === undefined || exportTask.status === 'PENDING' || exportTask.status === 'IN_PROGRESS' )&&
                <Alert severity="info" sx={{mt: 3}}>
                    <Stack alignItems="center" spacing={2} justifyContent="center" sx={{width: "100%"}}>
                        <CircularProgress  size={40} sx={{mx: 'auto'}} color="info"/>
                        {t('dialog.inProgressDescription')}
                    </Stack>
                </Alert>
            }
            {
                exportTask != null && exportTask.status === 'COMPLETED' &&
                <Alert severity="success" sx={{mt: 3}}>
                    {t('dialog.completedDescription')}
                </Alert>
            }
            {
                exportTask != null && exportTask.status === 'FAILED' &&
                <Alert severity="error" sx={{mt: 3}}>
                    {t('dialog.failedDescription')}
                    {exportTask.errors.map(error => error.message).join('. ')}
                </Alert>
            }
        </DialogContent>
        <DialogActions>
            <MDButton onClick={handleClose} color="info" variant="outlined">
                {t('dialog.cancel')}
            </MDButton>
            <MDButton onClick={handleDownloadFile} color="info"
                      variant="outlined"
                      disabled={exportTask?.status !== 'COMPLETED'}>
                {t('dialog.download')}
            </MDButton>
        </DialogActions>
    </>
}

export default ExportTaskDialogContent;